import { render } from "./WriteAFeedback.vue?vue&type=template&id=88e54310&ts=true"
import script from "./WriteAFeedback.vue?vue&type=script&lang=ts"
export * from "./WriteAFeedback.vue?vue&type=script&lang=ts"

import exportComponent from "/opt/build/repo/widget/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__